import * as React from 'react';
import Svg, { SvgProps, Path } from 'react-native-svg';

const CloudyIcon = (props: SvgProps) => <Svg
  width={32}
  height={32}
  viewBox='0 0 32 32'
  fill='none'
  {...props}
>
  <Path
    fillRule='evenodd'
    clipRule='evenodd'
    d='M22.5444 14.043C22.5444 14.043 22.6673 14.667 22.7092 14.673C24.9717 14.9956 26.6693 16.3153 26.6693 18.667C26.6693 21.2443 24.5799 23.3337 22.0026 23.3337H10.0026C7.42527 23.3337 5.33594 21.2443 5.33594 18.667C5.33594 16.3153 7.07542 14.3699 9.33792 14.0473C9.37984 14.0413 9.42091 14.0401 9.46077 14.043C10.0619 10.9788 12.7623 8.66699 16.0026 8.66699C19.243 8.66699 21.9433 10.9788 22.5444 14.043Z'
    fill='#F7FAFD'
  />
  <Path
    d='M10.3555 23.3337C7.58329 23.3337 5.33594 21.1448 5.33594 18.4448C5.33594 16.0864 7.05049 14.1181 9.33179 13.6576C10.116 10.7842 12.8055 8.66699 16.0026 8.66699C19.6169 8.66699 22.5824 11.3728 22.88 14.8181C25.0205 15.1043 26.6693 16.8925 26.6693 19.0559C26.6693 21.4184 24.7028 23.3337 22.2771 23.3337H10.3555Z'
    stroke='#003A70'
    strokeWidth='1.5'
    strokeLinecap='round'
    strokeLinejoin='round'
  />
</Svg>;

export default CloudyIcon;
